import React from "react";
import Particles from "react-tsparticles";

function Particle({lightMode}) {
  const paramConfig = {
    particles: {
      number: {
        value: 20,
        density: {
          enable: false,
        },
      },
      color: {
        value: "#ffffff",
      },
      opacity: {
        value: 0.1,
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3,
        },
      },
      line_linked: {
        enable: true,
      },
      move: {
        enable: true,
        random: true,
        speed: 12,
        direction: "top",
        out_mode: "out",
      },
    },
  };

  const paramConfigLight = {
    particles: {
      number: {
        //value: 160,
        value: 20,
        density: {
          enable: false
        }
      },
      color: {
        value: "#000000"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        //enable: false
        enable: true
      },
      move: {
        random: true,
        speed: 4,
        direction: "top",
        out_mode: "out"
      }
    }
  };
  return (
    <Particles
      className="mi-home-particle"
      options={lightMode ? paramConfigLight : paramConfig}
    />
  );
}

export default Particle;
